/**
 *
 * @author: Matthew Rawson @ 02/10/2017 16:01
 * @description:
 * @notes:
 */
import styled from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"


export default styled.div`
  position: absolute;
  top: 0;
  right: 0;

  ${minWidthMedia.tablet`
      right: auto;
      left: 50%;
      transform: translate3d(-50%, 0, 0)
  `}
`
